import React from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import { ReactComponent as PlusIcon } from "assets/icons/plus-large.svg";
import { ReactComponent as ShareIcon } from "assets/icons/share.svg";
import { ReactComponent as PrinterIcon } from "assets/icons/printer.svg";
import { RoundButton, RegularButton } from "components/Button";
import Page from "components/Page/Page";
import UpdatePatientForm from "./components/UpdatePatientForm";
import DetailSelector from "./components/DetailSelector";
import DeletePatientButton from "./components/DeletePatientButton";

const PatientDetails = () => {
  const { id } = useParams();

  return (
    <Page>
      <Card
        title="View Patient Details"
        subTitle={id ? `Patient id: ${id}` : "Following are the details"}
      >
        <div className="flex flex-wrap items-center justify-end gap-4 sm:mr-10">
          <RoundButton Icon={PlusIcon} />
          <RoundButton Icon={ShareIcon} />
          <RoundButton Icon={PrinterIcon} />
          <RegularButton color="Secondary" onClick={() => undefined}>
            <span>QUICK BILL</span>
          </RegularButton>
          <DeletePatientButton />
        </div>
        <UpdatePatientForm />
        <DetailSelector />
      </Card>
    </Page>
  );
};

export default PatientDetails;
